import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  Stack,
  Grid,
  Paper,
  Divider,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styled from "styled-components";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import { useTranslation } from "react-i18next";
import { messages } from "../../../locales/messages";

interface ToolsModalProps {
  open: boolean;
  onClose: () => void;
  handleToolClick?: () => void;
}

const ModalContainer = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 24px;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ToolItem = styled(Paper)`
  padding: 16px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  }
`;

const IconWrapper = styled.div`
  font-size: 40px;
  margin-bottom: 10px;
  color: #ff8038;
`;

export const ToolsModal: React.FC<ToolsModalProps> = ({
  open,
  onClose,
  handleToolClick,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="tools-modal-title"
      data-testid="tools-modal"
    >
      <ModalContainer>
        <ModalHeader>
          <Typography
            id="tools-modal-title"
            variant="h5"
            component="h2"
            fontWeight="bold"
          >
            {t(messages.Tools())}
          </Typography>
          <IconButton
            onClick={onClose}
            size="small"
            data-testid="tools-modal-close"
          >
            <CloseIcon />
          </IconButton>
        </ModalHeader>
        <Divider sx={{ mb: 3 }} />

        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4}>
            <Tooltip
              title={t(messages.bulkCalculateSaveDescription())}
              placement="top"
              arrow
            >
              <ToolItem
                elevation={2}
                onClick={handleToolClick}
                data-testid="bulk-calculate-save"
              >
                <IconWrapper>
                  <CurrencyExchangeIcon fontSize="large" />
                </IconWrapper>
                <Typography variant="subtitle1">
                  {t(messages.bulkCalculateSave())}
                </Typography>
              </ToolItem>
            </Tooltip>
          </Grid>
        </Grid>

        <Stack direction="row" spacing={2} justifyContent="flex-end" mt={4}>
          <Button variant="outlined" color="warning" onClick={onClose}>
            {t(messages.Close())}
          </Button>
        </Stack>
      </ModalContainer>
    </Modal>
  );
};
